import React, { useState, useEffect } from "react";
import BySheet from "./BySheet/BySheet";
import ByNames from "./ByNames/ByNames";
import BySheet2 from "./BySheet/BySheet2";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function OrderSheet() {
  /*   All States
   ********************************************* */
  const [activeTab, setActiveTab] = useState("by-sheet");
  const [activeSheetTab, setActiveSheetTab] = useState("sheet1");

  // The sizes the sheets accept: every size in Products -> Size Sets ->
  // All Sizes, in its sort order (user, 2026-10-27; replaced the separate
  // Possible Sizes list). Same shape as the old list: { id, sizeName, sortId }.
  const [possibleSizes, setPossibleSizes] = useState([]);

  /*   All Functions
   ********************************************* */
  const loadSizes = async () => {
    try {
      const { data } = await API.post(
        "/sales/products/sizes",
        { page: 1, limit: 9999 },
        { headers: authHeader() },
      );
      if (data.success) {
        setPossibleSizes(
          (data.data || []).map((s) => ({
            id: s.id,
            sizeName: s.name,
            sortId: s.sortId,
          })),
        );
      }
    } catch (err) {
      console.error("Failed to load order sheet sizes:", err.message);
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    loadSizes();
  }, []);
  return (
    <div
      className="flex-grow-1 "
      style={{
        borderRadius: "10px",
        position: "fixed",
        top: 0,
        width: "calc(100vw - 180px)",
        paddingLeft: 80,
        marginLeft: 180,
        zIndex: 101,
      }}
    >
      <div className="">
        <div className="ps-3 bg-white py-3 custom-shadow-sm d-flex justify-content-start align-items-center">
          <ul className="nav nav-tabs nav-bordered border-0 d-flex ">
            <li
              onClick={() => {
                setActiveTab("by-sheet");
              }}
              className=""
            >
              <button
                className={
                  activeTab === "by-sheet"
                    ? `btn btn-primary active bg-primary text-white`
                    : "nav-link"
                }
              >
                <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                <span className="d-none d-md-block"> Team Order Sheet</span>
              </button>
            </li>
            <li
              onClick={() => {
                setActiveTab("by-names");
              }}
              className=""
            >
              <button
                className={
                  activeTab === "by-names"
                    ? `btn btn-primary active bg-primary text-white`
                    : "nav-link"
                }
              >
                <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                <span className="d-none d-md-block">Player Order Sheet</span>
              </button>
            </li>
          </ul>
        </div>

        <div className="ps-2 tab-content mt-2">
          <div
            className={`tab-pane fade ${
              activeTab === "by-sheet" ? "show active" : ""
            }`}
          >
            {/* By Sheet tabs */}
            <ul className="nav nav-tabs nav-bordered border-0 d-flex mb-3">
              <li
                onClick={() => {
                  setActiveSheetTab("sheet1");
                }}
                className=""
              >
                <button
                  className={
                    activeSheetTab === "sheet1"
                      ? `nav-link rounded-0 border-1 border-secondary active bg-secondary text-white`
                      : "nav-link rounded-0 border-1 border-secondary shadow-sm"
                  }
                >
                  <span className="d-none d-md-block">Version 1</span>
                </button>
              </li>
              <li
                onClick={() => {
                  setActiveSheetTab("sheet2");
                }}
                className=""
              >
                <button
                  className={
                    activeSheetTab === "sheet2"
                      ? `nav-link rounded-0 border-1 border-secondary active bg-secondary text-white`
                      : "nav-link rounded-0 border-1 border-secondary shadow-sm"
                  }
                >
                  <span className="d-none d-md-block">Version 2</span>
                </button>
              </li>
            </ul>

            {/* By Sheet Component based on selected tab */}
            <div>
              {activeSheetTab === "sheet1" ? (
                <BySheet possibleSizes={possibleSizes} />
              ) : (
                <BySheet2 possibleSizes={possibleSizes} />
              )}
            </div>
          </div>
          <div
            className={`tab-pane fade ${
              activeTab === "by-names" ? "show active" : ""
            }`}
          >
            {/* By Names Component */}
            <div>
              <ByNames possibleSizes={possibleSizes} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
